import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GenerateLoaderStyled } from "./generate-loader-style";
import { Loader } from "../Loader";

// Define the component
const GenerateLoader: React.FC = () => {
  const { t } = useTranslation();
  const [messageIndex, setMessageIndex] = useState<number>(Math.floor(Math.random() * 7) + 1);

  useEffect(() => {
    const interval = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * 8) + 1;
      setMessageIndex(randomIndex);
    }, 15000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <GenerateLoaderStyled>
      <div className="inner">
        <div>
          <h3>{t('generate_loader_creating')}</h3>
          <br />
          <p className="tipText"><i>"{t(`generate_loader_tip_${messageIndex}`)}"</i></p>
          <p className="tipTitle"><b>{t('generate_loader_tip_title', { number: messageIndex })}</b></p>
        </div>
        <div>
          <Loader />
        </div>
      </div>
    </GenerateLoaderStyled>
  );
};

export default GenerateLoader;
